import { useParams, generatePath, useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import { NavigateOptions } from 'react-router/dist/lib/context'
import { ADMISSION_DENTISTRY, ADMISSION_OPTOMETRY } from '../pagesNew/AdmissionManagement/consts'

export const ROUTE_PLATFORM = `/:platform`

export const routes = {
  ROOT: '/',
  MAINTENANCE: '/maintenance',
  SIGN_IN: `/sign-in`,
  NOT_FOUND: '/not-found',
  BLOG_PAGES: `blog-pages`,
  ORGANIZE_CREATE_SUCCESS_STORIES: `blog-pages/success-stories/organize/create`,
  ORGANIZE_EDIT_SUCCESS_STORIES: `blog-pages/success-stories/organize/:id`,
  ORGANIZE_CREATE_STUDY_GUIDES: `blog-pages/study-guides/organize/create`,
  ORGANIZE_EDIT_STUDY_GUIDES: `blog-pages/study-guides/organize/:id`,
  ORGANIZE_CREATE_DENTAL_SCHOOL_STATISTICS: `blog-pages/dental-school-statistics/organize/create`,
  ORGANIZE_EDIT_DENTAL_SCHOOL_STATISTICS: `blog-pages/dental-school-statistics/organize/:id`,
  ORGANIZE_CREATE_OPTOMETRY_SCHOOL_STATISTICS: `blog-pages/optometry-school-statistics/organize/create`,
  ORGANIZE_EDIT_OPTOMETRY_SCHOOL_STATISTICS: `blog-pages/optometry-school-statistics/organize/:id`,
  CREATE_SUCCESS_STORY: `blog-pages/success-stories/create`,
  EDIT_SUCCESS_STORY: `blog-pages/success-stories/:successStoryId`,
  CREATE_STUDY_GUIDE: `blog-pages/study-guides/create`,
  EDIT_STUDY_GUIDE: `blog-pages/study-guides/:studyGuideId`,
  CREATE_PAT_STRATEGY: `blog-pages/pat-strategy/create`,
  EDIT_PAT_STRATEGY: `blog-pages/pat-strategy/:patStrategyId`,
  CREATE_DENTAL_SCHOOL: `dental-schools/create`,
  EDIT_DENTAL_SCHOOL: `dental-schools/:dentalSchoolId`,
  CREATE_OPTOMETRY_SCHOOL: `optometry-schools/create`,
  EDIT_OPTOMETRY_SCHOOL: `optometry-schools/:dentalSchoolId`,
  STUDY_NOTE: `study-notes`,
  FLASH_CARD: `flash-cards`,
  QUESTION_CATEGORY: `question-category`,
  QUESTION_LIST: `questions`,
  QUESTION_CREATE: `questions/create`,
  QUESTION_EDIT: `questions/:questionId`,
  QUESTION_TEMPLATE_EDIT: `question-template/:questionTemplateId`,
  CARS_QUESTION_LIST: `cars-questions`,
  CARS_QUESTION_CREATE: `cars-questions/create`,
  CARS_QUESTION_EDIT: `cars-questions/:questionPassageId`,
  CARS_QUESTION_TEMPLATE_EDIT: `cars-question-template/:templateId`,
  CARS_QUESTION_BANK_LIST: `cars-question-banks`,
  CARS_QUESTION_BANK_CREATE: `cars-question-banks/create`,
  CARS_QUESTION_BANK_EDIT: `cars-question-banks/:carsQuestionBankId`,
  CARS_GAMES_STATS: `cars-games-stats`,
  STATISTICS: `statistics`,
  QUESTION_BANK_LIST: `question-banks`,
  QUESTION_BANK_CREATE: `question-banks/create`,
  QUESTION_BANK_EDIT: `question-banks/:questionBankId`,
  CASE_BASED_SCENARIO_LIST: `case-based-scenario`,
  SCENARIOS_QB_LIST: `scenarios-qbank`,
  COMMUNITY_TESTLETS_LIST: `community-testlets`,
  OSCE_STANDALON_QB_LIST: `osce-standalon-qbs`,
  OSCE_MULTISELECT_QB_LIST: `osce-multiselect-qbs`,
  OSCE_RX_WRITING_QB_LIST: `osce-rx-writing-qbs`,
  STRATEGIES: `strategies`,
  RECOMMENDED_ARTICLES: 'recommended-articles',
  PRACTICE_TEST_LIST: `practice-tests`,
  PRACTICE_TEST_CREATE: `practice-tests/create`,
  PRACTICE_TEST_EDIT: `practice-tests/:practiceTestId`,
  MINI_TEST_CREATE: `mini-tests/create`,
  MINI_TEST_EDIT: `mini-tests/:practiceTestId`,
  CRASH_COURSE_LIST: `crash-courses`,
  CRASH_COURSE_CREATE: `crash-courses/create`,
  CRASH_COURSE_EDIT: `crash-courses/:crashCourseId`,
  CHEAT_SHEET: `cheat-sheets`,
  CHAPTER_NOTES: `chapter-notes`,
  COMMON_ELEMENTS: `common-elements`,
  TEAM_MEMBERS: `team-members`,
  USER_LIST: `users`,
  USER_EDIT: `users/:userId`,
  USER_EDIT_PT_DETAILS: `users/:userId/pt-details/:platformId`,
  USER_EDIT_PT_DETAILS_RESULT: `users/:userId/pt-details/:platformId/:practiceTestId`,
  UPGRADE_PAGE: `upgrade-page`,
  VIDEO_DASHBOARD: `videos`,
  VIDEOS_VIDEO_CATEGORY: `videos/:videoCategoryId`,
  VIDEOS_RESOURCE: `videos/:videoCategoryId/resource`,
  VIDEOS_RESOURCE_EDIT: `videos/:videoCategoryId/resource/:contentId`,
  VIDEOS_VIDEO: `videos/:videoCategoryId/video`,
  VIDEOS_VIDEO_EDIT: `videos/:videoCategoryId/video/:contentId`,
  VIDEOS_QUIZ: `videos/:videoCategoryId/quiz`,
  VIDEOS_QUIZ_EDIT: `videos/:videoCategoryId/quiz/:contentId`,
  VIDEOS_CHAPTER_COMPLETION_EDIT: `videos/:videoCategoryId/chapter-completion`,
  PRODUCTS: `products`,
  PRODUCTS_MEMBERSHIP_EDIT: `products/membership/:id`,
  PRODUCTS_EXTENSION_CREATE: `products/extension/create`,
  PRODUCTS_EXTENSION_EDIT: `products/extension/:id`,
  PRODUCTS_ADDITIONAL_TESTS_EDIT: `products/additional-tests/:id`,
  PRODUCTS_PAUSE_TOKEN_EDIT: `products/pause-token/:id`,
  ACCOUNT_SHARING: 'account-sharing',
  PROMO_CODES_LIST: `promo-codes`,
  PROMO_CODES_CREATE: `promo-codes/create`,
  PROMO_CODES_EDIT: `promo-codes/:promoCodeId`,
  PROMO_CODES_ANALYTICS: `promo-codes/analytics/:promoCodeId`,
  FAQ: `faq`,

  // AI
  TRAINING_DATA: `training-data`,
  GPT_GRADE_EDITOR: `training-data/gpt-grade-edit/:id`,
  TRAINING_GRADE_EDITOR: `training-data/training-grade-edit/:id`,
  RESPONSE_TESTS: `response-tests`,
  RESPONSE_TESTS_CREATE: `response-tests/create`,
  RESPONSE_TESTS_EDIT: `response-tests/:testId`,
  RESPONSE_FULL_LENGTH_TEST: `response-full-length-test`,
  TRAIN_AI_MODEL: `train-ai-model`,

  // Study tool pages
  CANADIAN_DAT_TIPS: `canadian-dat-tips`,
  MARKED_QUESTIONS: `marked-questions`,
  VIDEO_CONTENT: `video-content`,
  PAT_GENERATORS: `pat-generators`,
  PLATFORM_MOCK: `platform-mock`,
  PLATFORM_MOCK_CREATE: `platform-mock/create`,
  PLATFORM_MOCK_EDIT: `platform-mock/:practiceTestId`,
  IN_PERSON_MOCK: `in-person-mock`,
  IN_PERSON_MOCK_CREATE: `in-person-mock/create`,
  IN_PERSON_MOCK_EDIT: `in-person-mock/:practiceTestId`,
  COMMON_PTS: `common-pts`,
  COMMON_PTS_CREATE: `common-pts/create`,
  COMMON_PTS_EDIT: `common-pts/:practiceTestId`,
  CARS_PTS: `cars-pts`,
  CARS_PTS_CREATE: `cars-pts/create`,
  CARS_PTS_EDIT: `cars-pts/:practiceTestId`,
  CARS_PPS: `cars-pps`,
  CARS_PPS_CREATE: `cars-pps/create`,
  CARS_PPS_EDIT: `cars-pps/:practiceTestId`,
  DAILY_CARS: `daily-cars`,
  DAILY_CARS_CREATE: `daily-cars/create`,
  DAILY_CARS_EDIT: `daily-cars/:practiceTestId`,
  CREATE_TEST: `create-test`,
  FULL_LENGTH_TESTS: `full-length-tests`,
  PAST_TEST_RESULTS: `past-test-results`,
  PRACTICE_RESULTS: `practice-results`,
  PERFORMANCE: `performance`,
  ACHIEVEMENTS: `achievements`,
  ACHIEVEMENTS_CREATE: `achievements/create`,
  ACHIEVEMENTS_EDIT: `achievements/:achievementId`,
  REWARDS_CREATE: `achievements/rewards/create`,
  REWARDS_EDIT: `achievements/rewards/:rewardId`,
  DAILY_WARMUP: `daily-warmup`,
  DAILY_GOAL: 'daily-goal',
  GAME_CHALLENGES: 'game-challenges',
  CONTENT_COMPLETION: 'content-completion',
  INFLUENCER_HUB: 'influencer-hub',
  STUDY_SCHEDULE: 'study-schedule',
  CARS_PLUGIN: 'cars-plugin',
  CARS_PLUGIN_EXAM_SECTION: 'cars-plugin/exam-section/:sectionId',

  // Memberships
  EMAILS: `emails`,

  // Admission
  DENTISTRY: ADMISSION_DENTISTRY,
  OPTOMETRY: ADMISSION_OPTOMETRY,

  // Institutional Code
  INSTITUTIONAL_CODES: 'institutional-codes',
  INSTITUTIONAL_CODES_EDIT: 'institutional-codes/:institutionalCodeId',
}

export const cmsRoutes = {
  ROOT: routes.ROOT,
  MAINTENANCE: routes.MAINTENANCE,
  SIGN_IN: routes.SIGN_IN,
  PLATFORM: ROUTE_PLATFORM,
  NOT_FOUND: routes.NOT_FOUND,
  BLOG_PAGES: `${ROUTE_PLATFORM}/${routes.BLOG_PAGES}`,
  ORGANIZE_CREATE_SUCCESS_STORIES: `${ROUTE_PLATFORM}/${routes.ORGANIZE_CREATE_SUCCESS_STORIES}`,
  ORGANIZE_EDIT_SUCCESS_STORIES: `${ROUTE_PLATFORM}/${routes.ORGANIZE_EDIT_SUCCESS_STORIES}`,
  ORGANIZE_CREATE_STUDY_GUIDES: `${ROUTE_PLATFORM}/${routes.ORGANIZE_CREATE_STUDY_GUIDES}`,
  ORGANIZE_EDIT_STUDY_GUIDES: `${ROUTE_PLATFORM}/${routes.ORGANIZE_EDIT_STUDY_GUIDES}`,
  ORGANIZE_CREATE_DENTAL_SCHOOL_STATISTICS: `${ROUTE_PLATFORM}/${routes.ORGANIZE_CREATE_DENTAL_SCHOOL_STATISTICS}`,
  ORGANIZE_EDIT_DENTAL_SCHOOL_STATISTICS: `${ROUTE_PLATFORM}/${routes.ORGANIZE_EDIT_DENTAL_SCHOOL_STATISTICS}`,
  ORGANIZE_CREATE_OPTOMETRY_SCHOOL_STATISTICS: `${ROUTE_PLATFORM}/${routes.ORGANIZE_CREATE_OPTOMETRY_SCHOOL_STATISTICS}`,
  ORGANIZE_EDIT_OPTOMETRY_SCHOOL_STATISTICS: `${ROUTE_PLATFORM}/${routes.ORGANIZE_EDIT_OPTOMETRY_SCHOOL_STATISTICS}`,
  CREATE_SUCCESS_STORY: `${ROUTE_PLATFORM}/${routes.CREATE_SUCCESS_STORY}`,
  EDIT_SUCCESS_STORY: `${ROUTE_PLATFORM}/${routes.EDIT_SUCCESS_STORY}`,
  CREATE_STUDY_GUIDE: `${ROUTE_PLATFORM}/${routes.CREATE_STUDY_GUIDE}`,
  EDIT_STUDY_GUIDE: `${ROUTE_PLATFORM}/${routes.EDIT_STUDY_GUIDE}`,
  CREATE_PAT_STRATEGY: `${ROUTE_PLATFORM}/${routes.CREATE_PAT_STRATEGY}`,
  EDIT_PAT_STRATEGY: `${ROUTE_PLATFORM}/${routes.EDIT_PAT_STRATEGY}`,
  CREATE_DENTAL_SCHOOL: `${ROUTE_PLATFORM}/${routes.CREATE_DENTAL_SCHOOL}`,
  EDIT_DENTAL_SCHOOL: `${ROUTE_PLATFORM}/${routes.EDIT_DENTAL_SCHOOL}`,
  CREATE_OPTOMETRY_SCHOOL: `${ROUTE_PLATFORM}/${routes.CREATE_OPTOMETRY_SCHOOL}`,
  EDIT_OPTOMETRY_SCHOOL: `${ROUTE_PLATFORM}/${routes.EDIT_OPTOMETRY_SCHOOL}`,
  STUDY_NOTE: `${ROUTE_PLATFORM}/${routes.STUDY_NOTE}`,
  FLASH_CARD: `${ROUTE_PLATFORM}/${routes.FLASH_CARD}`,
  QUESTION_CATEGORY: `${ROUTE_PLATFORM}/${routes.QUESTION_CATEGORY}`,
  QUESTION_LIST: `${ROUTE_PLATFORM}/${routes.QUESTION_LIST}`,
  QUESTION_CREATE: `${ROUTE_PLATFORM}/${routes.QUESTION_CREATE}`,
  QUESTION_EDIT: `${ROUTE_PLATFORM}/${routes.QUESTION_EDIT}`,
  QUESTION_TEMPLATE_EDIT: `${ROUTE_PLATFORM}/${routes.QUESTION_TEMPLATE_EDIT}`,
  CARS_QUESTION_LIST: `${ROUTE_PLATFORM}/${routes.CARS_QUESTION_LIST}`,
  CARS_QUESTION_CREATE: `${ROUTE_PLATFORM}/${routes.CARS_QUESTION_CREATE}`,
  CARS_QUESTION_EDIT: `${ROUTE_PLATFORM}/${routes.CARS_QUESTION_EDIT}`,
  CARS_QUESTION_TEMPLATE_EDIT: `${ROUTE_PLATFORM}/${routes.CARS_QUESTION_TEMPLATE_EDIT}`,
  CARS_QUESTION_BANK_LIST: `${ROUTE_PLATFORM}/${routes.CARS_QUESTION_BANK_LIST}`,
  CARS_QUESTION_BANK_CREATE: `${ROUTE_PLATFORM}/${routes.CARS_QUESTION_BANK_CREATE}`,
  CARS_QUESTION_BANK_EDIT: `${ROUTE_PLATFORM}/${routes.CARS_QUESTION_BANK_EDIT}`,
  CARS_GAMES_STATS: `${ROUTE_PLATFORM}/${routes.CARS_GAMES_STATS}`,
  STATISTICS: `${ROUTE_PLATFORM}/${routes.STATISTICS}`,
  QUESTION_BANK_LIST: `${ROUTE_PLATFORM}/${routes.QUESTION_BANK_LIST}`,
  QUESTION_BANK_CREATE: `${ROUTE_PLATFORM}/${routes.QUESTION_BANK_CREATE}`,
  QUESTION_BANK_EDIT: `${ROUTE_PLATFORM}/${routes.QUESTION_BANK_EDIT}`,
  CASE_BASED_SCENARIO_LIST: `${ROUTE_PLATFORM}/${routes.CASE_BASED_SCENARIO_LIST}`,
  SCENARIOS_QB_LIST: `${ROUTE_PLATFORM}/${routes.SCENARIOS_QB_LIST}`,
  COMMUNITY_TESTLETS_LIST: `${ROUTE_PLATFORM}/${routes.COMMUNITY_TESTLETS_LIST}`,
  OSCE_STANDALON_QB_LIST: `${ROUTE_PLATFORM}/${routes.OSCE_STANDALON_QB_LIST}`,
  OSCE_MULTISELECT_QB_LIST: `${ROUTE_PLATFORM}/${routes.OSCE_MULTISELECT_QB_LIST}`,
  OSCE_RX_WRITING_QB_LIST: `${ROUTE_PLATFORM}/${routes.OSCE_RX_WRITING_QB_LIST}`,
  STRATEGIES: `${ROUTE_PLATFORM}/${routes.STRATEGIES}`,
  RECOMMENDED_ARTICLES: `${ROUTE_PLATFORM}/${routes.RECOMMENDED_ARTICLES}`,
  PRACTICE_TEST_LIST: `${ROUTE_PLATFORM}/${routes.PRACTICE_TEST_LIST}`,
  PRACTICE_TEST_CREATE: `${ROUTE_PLATFORM}/${routes.PRACTICE_TEST_CREATE}`,
  PRACTICE_TEST_EDIT: `${ROUTE_PLATFORM}/${routes.PRACTICE_TEST_EDIT}`,
  MINI_TEST_CREATE: `${ROUTE_PLATFORM}/${routes.MINI_TEST_CREATE}`,
  MINI_TEST_EDIT: `${ROUTE_PLATFORM}/${routes.MINI_TEST_EDIT}`,
  CRASH_COURSE_LIST: `${ROUTE_PLATFORM}/${routes.CRASH_COURSE_LIST}`,
  CRASH_COURSE_CREATE: `${ROUTE_PLATFORM}/${routes.CRASH_COURSE_CREATE}`,
  CRASH_COURSE_EDIT: `${ROUTE_PLATFORM}/${routes.CRASH_COURSE_EDIT}`,
  CHEAT_SHEET: `${ROUTE_PLATFORM}/${routes.CHEAT_SHEET}`,
  CHAPTER_NOTES: `${ROUTE_PLATFORM}/${routes.CHAPTER_NOTES}`,
  COMMON_ELEMENTS: `${ROUTE_PLATFORM}/${routes.COMMON_ELEMENTS}`,
  TEAM_MEMBERS: `${ROUTE_PLATFORM}/${routes.TEAM_MEMBERS}`,
  USER_LIST: `${ROUTE_PLATFORM}/${routes.USER_LIST}`,
  USER_EDIT: `${ROUTE_PLATFORM}/${routes.USER_EDIT}`,
  USER_EDIT_PT_DETAILS: `${ROUTE_PLATFORM}/${routes.USER_EDIT_PT_DETAILS}`,
  USER_EDIT_PT_DETAILS_RESULT: `${ROUTE_PLATFORM}/${routes.USER_EDIT_PT_DETAILS_RESULT}`,
  UPGRADE_PAGE: `${ROUTE_PLATFORM}/${routes.UPGRADE_PAGE}`,
  VIDEO_DASHBOARD: `${ROUTE_PLATFORM}/${routes.VIDEO_DASHBOARD}`,
  VIDEOS_VIDEO_CATEGORY: `${ROUTE_PLATFORM}/${routes.VIDEOS_VIDEO_CATEGORY}`,
  VIDEOS_RESOURCE: `${ROUTE_PLATFORM}/${routes.VIDEOS_RESOURCE}`,
  VIDEOS_RESOURCE_EDIT: `${ROUTE_PLATFORM}/${routes.VIDEOS_RESOURCE_EDIT}`,
  VIDEOS_VIDEO: `${ROUTE_PLATFORM}/${routes.VIDEOS_VIDEO}`,
  VIDEOS_VIDEO_EDIT: `${ROUTE_PLATFORM}/${routes.VIDEOS_VIDEO_EDIT}`,
  VIDEOS_QUIZ: `${ROUTE_PLATFORM}/${routes.VIDEOS_QUIZ}`,
  VIDEOS_QUIZ_EDIT: `${ROUTE_PLATFORM}/${routes.VIDEOS_QUIZ_EDIT}`,
  VIDEOS_CHAPTER_COMPLETION_EDIT: `${ROUTE_PLATFORM}/${routes.VIDEOS_CHAPTER_COMPLETION_EDIT}`,
  PRODUCTS: `${ROUTE_PLATFORM}/${routes.PRODUCTS}`,
  PRODUCTS_MEMBERSHIP_EDIT: `${ROUTE_PLATFORM}/${routes.PRODUCTS_MEMBERSHIP_EDIT}`,
  PRODUCTS_EXTENSION_EDIT: `${ROUTE_PLATFORM}/${routes.PRODUCTS_EXTENSION_EDIT}`,
  PRODUCTS_EXTENSION_CREATE: `${ROUTE_PLATFORM}/${routes.PRODUCTS_EXTENSION_CREATE}`,
  PRODUCTS_ADDITIONAL_TESTS_EDIT: `${ROUTE_PLATFORM}/${routes.PRODUCTS_ADDITIONAL_TESTS_EDIT}`,
  PRODUCTS_PAUSE_TOKEN_EDIT: `${ROUTE_PLATFORM}/${routes.PRODUCTS_PAUSE_TOKEN_EDIT}`,
  ACCOUNT_SHARING: `${ROUTE_PLATFORM}/${routes.ACCOUNT_SHARING}`,
  PROMO_CODES_LIST: `${ROUTE_PLATFORM}/${routes.PROMO_CODES_LIST}`,
  PROMO_CODES_CREATE: `${ROUTE_PLATFORM}/${routes.PROMO_CODES_CREATE}`,
  PROMO_CODES_EDIT: `${ROUTE_PLATFORM}/${routes.PROMO_CODES_EDIT}`,
  PROMO_CODES_ANALYTICS: `${ROUTE_PLATFORM}/${routes.PROMO_CODES_ANALYTICS}`,
  FAQ: `${ROUTE_PLATFORM}/${routes.FAQ}`,

  // AI
  TRAINING_DATA: `${ROUTE_PLATFORM}/${routes.TRAINING_DATA}`,
  GPT_GRADE_EDITOR: `${ROUTE_PLATFORM}/${routes.GPT_GRADE_EDITOR}`,
  TRAINING_GRADE_EDITOR: `${ROUTE_PLATFORM}/${routes.TRAINING_GRADE_EDITOR}`,
  RESPONSE_TESTS: `${ROUTE_PLATFORM}/${routes.RESPONSE_TESTS}`,
  RESPONSE_TESTS_CREATE: `${ROUTE_PLATFORM}/${routes.RESPONSE_TESTS_CREATE}`,
  RESPONSE_TESTS_EDIT: `${ROUTE_PLATFORM}/${routes.RESPONSE_TESTS_EDIT}`,
  RESPONSE_FULL_LENGTH_TEST: `${ROUTE_PLATFORM}/${routes.RESPONSE_FULL_LENGTH_TEST}`,
  TRAIN_AI_MODEL: `${ROUTE_PLATFORM}/${routes.TRAIN_AI_MODEL}`,

  // Study tool pages
  CANADIAN_DAT_TIPS: `${ROUTE_PLATFORM}/${routes.CANADIAN_DAT_TIPS}`,
  MARKED_QUESTIONS: `${ROUTE_PLATFORM}/${routes.MARKED_QUESTIONS}`,
  PAT_GENERATORS: `${ROUTE_PLATFORM}/${routes.PAT_GENERATORS}`,
  PLATFORM_MOCK: `${ROUTE_PLATFORM}/${routes.PLATFORM_MOCK}`,
  PLATFORM_MOCK_CREATE: `${ROUTE_PLATFORM}/${routes.PLATFORM_MOCK_CREATE}`,
  PLATFORM_MOCK_EDIT: `${ROUTE_PLATFORM}/${routes.PLATFORM_MOCK_EDIT}`,
  IN_PERSON_MOCK: `${ROUTE_PLATFORM}/${routes.IN_PERSON_MOCK}`,
  IN_PERSON_MOCK_CREATE: `${ROUTE_PLATFORM}/${routes.IN_PERSON_MOCK_CREATE}`,
  IN_PERSON_MOCK_EDIT: `${ROUTE_PLATFORM}/${routes.IN_PERSON_MOCK_EDIT}`,
  COMMON_PTS: `${ROUTE_PLATFORM}/${routes.COMMON_PTS}`,
  COMMON_PTS_CREATE: `${ROUTE_PLATFORM}/${routes.COMMON_PTS_CREATE}`,
  COMMON_PTS_EDIT: `${ROUTE_PLATFORM}/${routes.COMMON_PTS_EDIT}`,
  CARS_PTS: `${ROUTE_PLATFORM}/${routes.CARS_PTS}`,
  CARS_PTS_CREATE: `${ROUTE_PLATFORM}/${routes.CARS_PTS_CREATE}`,
  CARS_PTS_EDIT: `${ROUTE_PLATFORM}/${routes.CARS_PTS_EDIT}`,
  CARS_PPS: `${ROUTE_PLATFORM}/${routes.CARS_PPS}`,
  CARS_PPS_CREATE: `${ROUTE_PLATFORM}/${routes.CARS_PPS_CREATE}`,
  CARS_PPS_EDIT: `${ROUTE_PLATFORM}/${routes.CARS_PPS_EDIT}`,
  DAILY_CARS: `${ROUTE_PLATFORM}/${routes.DAILY_CARS}`,
  DAILY_CARS_CREATE: `${ROUTE_PLATFORM}/${routes.DAILY_CARS_CREATE}`,
  DAILY_CARS_EDIT: `${ROUTE_PLATFORM}/${routes.DAILY_CARS_EDIT}`,
  CREATE_TEST: `${ROUTE_PLATFORM}/${routes.CREATE_TEST}`,
  FULL_LENGTH_TESTS: `${ROUTE_PLATFORM}/${routes.FULL_LENGTH_TESTS}`,
  VIDEO_CONTENT: `${ROUTE_PLATFORM}/${routes.VIDEO_CONTENT}`,
  PAST_TEST_RESULTS: `${ROUTE_PLATFORM}/${routes.PAST_TEST_RESULTS}`,
  PRACTICE_RESULTS: `${ROUTE_PLATFORM}/${routes.PRACTICE_RESULTS}`,
  PERFORMANCE: `${ROUTE_PLATFORM}/${routes.PERFORMANCE}`,
  ACHIEVEMENTS: `${ROUTE_PLATFORM}/${routes.ACHIEVEMENTS}`,
  ACHIEVEMENTS_CREATE: `${ROUTE_PLATFORM}/${routes.ACHIEVEMENTS_CREATE}`,
  ACHIEVEMENTS_EDIT: `${ROUTE_PLATFORM}/${routes.ACHIEVEMENTS_EDIT}`,
  REWARDS_CREATE: `${ROUTE_PLATFORM}/${routes.REWARDS_CREATE}`,
  REWARDS_EDIT: `${ROUTE_PLATFORM}/${routes.REWARDS_EDIT}`,
  DAILY_WARMUP: `${ROUTE_PLATFORM}/${routes.DAILY_WARMUP}`,
  DAILY_GOAL: `${ROUTE_PLATFORM}/${routes.DAILY_GOAL}`,
  GAME_CHALLENGES: `${ROUTE_PLATFORM}/${routes.GAME_CHALLENGES}`,
  CONTENT_COMPLETION: `${ROUTE_PLATFORM}/${routes.CONTENT_COMPLETION}`,
  INFLUENCER_HUB: `${ROUTE_PLATFORM}/${routes.INFLUENCER_HUB}`,
  STUDY_SCHEDULE: `${ROUTE_PLATFORM}/${routes.STUDY_SCHEDULE}`,
  CARS_PLUGIN: `${ROUTE_PLATFORM}/${routes.CARS_PLUGIN}`,
  CARS_PLUGIN_EXAM_SECTION: `${ROUTE_PLATFORM}/${routes.CARS_PLUGIN_EXAM_SECTION}`,

  // Memberships
  EMAILS: `${ROUTE_PLATFORM}/${routes.EMAILS}`,

  // Admission
  DENTISTRY: `${ROUTE_PLATFORM}/${routes.DENTISTRY}`,
  OPTOMETRY: `${ROUTE_PLATFORM}/${routes.OPTOMETRY}`,

  // Institutional Code
  INSTITUTIONAL_CODES: `${ROUTE_PLATFORM}/${routes.INSTITUTIONAL_CODES}`,
  INSTITUTIONAL_CODES_EDIT: `${ROUTE_PLATFORM}/${routes.INSTITUTIONAL_CODES_EDIT}`,
} as const

export const DEFAULT_REDIRECT_PATHNAME = cmsRoutes.CRASH_COURSE_LIST
export const DEFAULT_MARKETING_GROUP_REDIRECT_PATHNAME = cmsRoutes.USER_LIST
export const DEFAULT_INBDE_REDIRECT_PATHNAME = cmsRoutes.BLOG_PAGES
export const DEFAULT_NBDHE_REDIRECT_PATHNAME = cmsRoutes.BLOG_PAGES
export const DEFAULT_NDEB_REDIRECT_PATHNAME = cmsRoutes.BLOG_PAGES
export const DEFAULT_GRE_REDIRECT_PATHNAME = cmsRoutes.BLOG_PAGES
export const DEFAULT_NBEO_REDIRECT_PATHNAME = cmsRoutes.BLOG_PAGES
export const DEFAULT_ADMISSION_REDIRECT_PATHNAME = cmsRoutes.DENTISTRY
export const DEFAULT_CASPER_REDIRECT_PATHNAME = cmsRoutes.QUESTION_LIST
export const DEFAULT_CARS_REDIRECT_PATHNAME = cmsRoutes.QUESTION_LIST
export const DEFAULT_MCAT_REDIRECT_PATHNAME = cmsRoutes.CARS_PLUGIN

export type RouteKey = keyof typeof cmsRoutes
export type RouteValue = (typeof cmsRoutes)[RouteKey]

type PlatformParams = { platform: string }

export const useLink = () => {
  const navigate = useNavigate()
  const currentRouteParams = useParams<PlatformParams>() as PlatformParams

  // Replaces parameters in the route template (with default params from the current route)
  const getLink = useCallback(
    (route: RouteValue, params: Record<string, string | number> = {}, searchParams?: URLSearchParams) =>
      generatePath(route, { ...currentRouteParams, ...params }) + (searchParams ? `?${searchParams.toString()}` : ''),
    [currentRouteParams]
  )

  // Navigates to the route template with replaced parameters
  const navigateCustom = useCallback(
    (
      route: RouteValue,
      params: Record<string, string | number> = {},
      options?: NavigateOptions & { searchParams?: URLSearchParams }
    ) => {
      const { searchParams, ...otherOptions } = options ?? {}
      return navigate(getLink(route, params, searchParams), otherOptions)
    },
    [getLink]
  )

  return {
    getLink,
    navigate: navigateCustom,
  }
}
